export const MODAL_TYPES = {
    CONFIRM_MODAL: "CONFIRM_MODAL",
    VERSION_MODAL: "VERSION_MODAL",
    CUSTOM_MODAL: "CUSTOM_MODAL"
};
